import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { CHALLENGE_SURVEY_OPTIONS, colors, constants, stripEmoji } from "utils";

const TEAM_TIME_BANNER_RESPONSES = {
  HARD: "Struggle is normal! Tell your team where you are stuck.",
  OK: "Great! Share your first step or ask a question!",
  EASY: "Awesome! Share your strategy to guide your team.",
};

const AUTO_DISMISS_MS = 4000;

export const PostSoloTimeBanner = ({ onSubmit, onDismiss }) => {
  const [selectedValue, setSelectedValue] = useState(null);
  const dismissTimeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      if (dismissTimeoutRef.current) {
        clearTimeout(dismissTimeoutRef.current);
      }
    };
  }, []);

  const handleClick = (value) => {
    if (selectedValue) return;
    setSelectedValue(value);
    onSubmit(value);
    dismissTimeoutRef.current = setTimeout(() => {
      onDismiss();
    }, AUTO_DISMISS_MS);
  };

  return (
    <BannerContainer role="region" aria-live="polite" aria-atomic="true">
      {selectedValue ? (
        <Title>{TEAM_TIME_BANNER_RESPONSES[selectedValue]}</Title>
      ) : (
        <>
          <Title id="post-solo-time-prompt">How did you feel about solving this problem in Solo Time?</Title>
          <ButtonsRow role="group" aria-labelledby="post-solo-time-prompt">
            {CHALLENGE_SURVEY_OPTIONS.map((option) => (
              <CTAButton
                key={option.value}
                onClick={() => handleClick(option.value)}
                type="button"
                aria-label={stripEmoji(option.label)}
              >
                {option.label}
              </CTAButton>
            ))}
          </ButtonsRow>
        </>
      )}
    </BannerContainer>
  );
};

const BannerContainer = styled.div`
  /* Per the layout spec the banner spans the middle content + control rail
     area: from just right of the left column to 24px off the screen edge. */
  position: fixed;
  bottom: 16px;
  left: 429px;
  right: 24px;

  @media ${constants.TABLET_MEDIA_QUERY} {
    left: 408px;
  }
  background: ${colors.blue100};
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  z-index: 1;
`;

const Title = styled.p`
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.25px;
  color: ${colors.nightlyWoods500};
  text-align: center;
  margin: 0;
`;

const ButtonsRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  width: 100%;
`;

const CTAButton = styled.button`
  flex: 0 0 auto;
  background: white;
  border: 1px solid ${colors.blue500};
  border-radius: 100px;
  height: 48px;
  padding: 8px 16px;
  font-family: "Roboto", sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: ${colors.blue500};
  letter-spacing: 0.1px;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    background: ${colors.blue50};
  }

  &:focus-visible {
    outline: 2px solid ${colors.blue800};
    outline-offset: 2px;
    background: ${colors.blue50};
  }
`;
